import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Button, Tooltip } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";

function LayerNavigator({ layers, selectedId, onSelect, visibleCount = 3 }) {
  const [startIndex, setStartIndex] = useState(0);

  const canPrev = startIndex > 0;
  const canNext = startIndex + visibleCount < layers.length;

  const handlePrev = () => {
    if (canPrev) setStartIndex((prev) => prev - visibleCount);
  };

  const handleNext = () => {
    if (canNext) setStartIndex((prev) => prev + visibleCount);
  };

  const visibleLayers = layers.slice(startIndex, startIndex + visibleCount);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={1}
      sx={{
        flexWrap: "nowrap",
        overflowX: "hidden",
        height: "40px",
        px: 1,
      }}
    >
      <Button
        onClick={handlePrev}
        disabled={!canPrev}
        sx={{
          color: "#000",
          boxShadow: "none",
          minWidth: 32,
          height: "28px !important",
          padding: 0,
          borderRadius: 1,
          "& svg": {
            fontSize: 20,
          },
        }}
      >
        <ArrowBackIosNew />
      </Button>

      {visibleLayers.map((layer) => (
        <Tooltip key={layer.id} title={layer.label} arrow placement="top">
          <Button
            variant="contained"
            onClick={() => onSelect(layer.id)}
            sx={{
              flex: 1,
              backgroundColor: selectedId === layer.id ? "#1976d2" : "#fff",
              color: selectedId === layer.id ? "#fff" : "#1F2225",
              fontSize: { xs: "9px", sm: "11px", md: "13px" },
              minWidth: { xs: 48, sm: 70, md: "90px !important" },
              maxWidth: { xs: 80, sm: 110, md: "160px !important" },
              height: { xs: "28px !important", sm: 34, md: "40px !important" },
              minHeight: "unset", // ✅ override mặc định
              lineHeight: 1, // ✅ tránh đẩy cao vì line-height
              padding: "2px 4px", // ✅ override padding mặc định
              textTransform: "none",
              border: "1px solid #C7C9CB",
              boxShadow: "none",
              fontWeight: 400,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              "&:hover": {
                backgroundColor: selectedId === layer.id ? "#115293" : "#e0e0e0",
              },
            }}
          >
            {layer.label}
          </Button>
        </Tooltip>
      ))}

      <Button
        onClick={handleNext}
        disabled={!canNext}
        sx={{
          color: "#000",
          boxShadow: "none",
          minWidth: 32,
          height: "28px !important",
          padding: 0,
          borderRadius: 1,
          "& svg": {
            fontSize: 20,
          },
        }}
      >
        <ArrowForwardIos />
      </Button>
    </Box>
  );
}

LayerNavigator.propTypes = {
  layers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedId: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  visibleCount: PropTypes.number,
};

LayerNavigator.defaultProps = {
  visibleCount: 3,
};

export default LayerNavigator;
